<template>
  <div style="height: 200px">
    <canvas ref="canvas" width="500px" height="210px"></canvas>
  </div>
</template>

<script>
  import {Bar, Line, mixins} from 'vue-chartjs'

  const uri = '/api/proj/report/academy-fund-by-year-statistics';

  export default {
    props:["startDate","endDate","adeptId"],
    extends: Bar,
    mixins: [mixins.reactiveData],
    data() {
      return {
        chartData: null,
        loading: false,
        options: {
          responsive: false,
          // maintainAspectRatio: false, // 保持长宽比

          title: {
            display: true,
            text: '项目经费年度统计'
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: '年度'
              }
            }],
            yAxes: [{
              type: 'linear',
              display: true,
              position: 'left',
              ticks:{
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '到款额（万元）'
              },
              id: 'y-axis-1',
            }, {
              type: 'linear',
              display: true,
              position: 'right',
              ticks:{
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: '合同额（万元）'
              },
              id: 'y-axis-2',

              // grid line settings
              gridLines: {
                drawOnChartArea: false,
              },
            }]
          }
        }
      }
    },
    watch:{
      "startDate":'get',
      "endDate":'get',
      "adeptId":'get'
    },
    created() {
      this.get();
    },
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
    computed: {
    },
    methods:{
      get(){
        if(this.loading || !this.startDate || !this.endDate){
          return
        }
        this.loading = true;
        let params = {"incomeDateStart":this.startDate,"incomeDateEnd":this.endDate,"adeptId":this.adeptId};
        this.axios.get(uri, {params: params}).then(
          rsp => {
            this.chartData = rsp.data;
            this.loading = false;
          })
      }
    }
  }
</script>

<style scoped>

</style>
